import React from 'react';
import { specialtyPages } from '../data/specialty';
import { PageIntro } from '../components/PageIntro';
import { ContentSections, Questions, RelatedLinks } from '../components/ContentSections';
import { FinalCta } from '../components/FinalCta';
export function SpecialtyPage({
  page
}: {
  page: string;
}) {
  const data = specialtyPages[page];
  const sections = data.sections.map((section, i) => i === 0 ? {
    ...section,
    image: data.image,
    alt: data.imageAlt
  } : section);
  return <><PageIntro data={data} id={page} data-id="element-1681" data-mp="1k0ddf3dwo2p3" /><ContentSections sections={sections} data-id="element-1682" data-mp="1jzk4pwvdz34b" /><Questions items={data.faqs} data-id="element-1683" data-mp="1k0lmek6wqnv0" /><RelatedLinks links={data.related} data-id="element-1684" data-mp="1ozg9hybwqykx" /><FinalCta data-id="element-1685" data-mp="1oyertb0dzdu8" /></>;
}